import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GruppeTier } from '../classes/gruppe-tier';

@Component({
    selector: 'kiene-gruppe-tier-bemerkung-dialog',
    templateUrl: './gruppe-tier-bemerkung-dialog.component.html',
    styleUrls: ['./gruppe-tier-bemerkung-dialog.component.scss'],
})
export class GruppeTierBemerkungDialogComponent implements OnInit {
    tier: GruppeTier;

    constructor(
        public dialogRef: MatDialogRef<GruppeTierBemerkungDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.tier = data.tier;
    }

    ngOnInit(): void {}
}
